export enum QuickFilterType {
    COMMUNITY_VERIFIED = 'Community Verified',
    TOP_CONTRIBUTORS = 'Top Contributors',
    FOLLOWING = 'Following',
    NEWEST = 'Newest'
}

export type QuickFilterKey = keyof typeof QuickFilterType;
